import { render, staticRenderFns } from "./classPerformanceStatistics.vue?vue&type=template&id=8f2fbb66&scoped=true"
import script from "./classPerformanceStatistics.vue?vue&type=script&lang=js"
export * from "./classPerformanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./classPerformanceStatistics.vue?vue&type=style&index=0&id=8f2fbb66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2fbb66",
  null
  
)

export default component.exports